import { events } from 'services/analytics';
import { AnalyticsEventLocation } from 'services/analytics/entities';
import { AnalyticsEvent } from 'services/analytics/events';
import { SongType } from 'services/api/entities';
import { AIGeneratorPrompt, PromptType } from 'services/store/ai/types';
import { DownloadInfo } from 'types';

export const makeAddToLibraryHandler =
  (
    shouldDisplayEmailConfirmationDialog: boolean,
    onEmailConfirmationDialogShouldOpen: () => void,
    isInLibrary: boolean,
    addToLibrary: () => void
  ) =>
  () => {
    if (shouldDisplayEmailConfirmationDialog) {
      onEmailConfirmationDialogShouldOpen();
      return;
    }

    if (isInLibrary) {
      return;
    }

    addToLibrary();
  };

export const makeAnalyticsTrackDownload =
  (
    track: (event: AnalyticsEvent) => void,
    prompts: AIGeneratorPrompt[],
    promptId: string,
    title: string,
    songType: SongType,
    location: AnalyticsEventLocation
  ) =>
  (downloadInfo: DownloadInfo) => {
    const prompt = prompts.find((p) => p.id === promptId);

    if (!prompt) {
      return;
    }

    if (prompt.promptType === PromptType.TextToMusic) {
      track(
        events.downloadEvent(title, '', downloadInfo, true, songType, location)
      );
      return;
    }

    const { primaryGenre, microGenre } = prompt;
    const genre = microGenre ?? primaryGenre;

    track(
      events.downloadEvent(
        title,
        genre ?? '',
        downloadInfo,
        true,
        songType,
        location
      )
    );
  };
